import React from "react";
import PropTypes from "prop-types";
import { Breadcrumb } from "react-bootstrap";

const KnoaBreadcrumb = ({
                          href,
                          firstLevelText,
                          href2,
                          secondLevelText,
                          href3,
                          thirdLevelText,
                          forthLevelText,
                          onClick2,
                          onClick3
                        }) => {
  const renderItems = () => {
    const items = [];

    if (href && firstLevelText) {
      items.push(
          <Breadcrumb.Item key="1" href={href}>
            {firstLevelText}
          </Breadcrumb.Item>
      );
    }

    if (href2 && secondLevelText) {
      items.push(
          <Breadcrumb.Item key="2" href={href2} onClick={onClick2 || null}>
            {secondLevelText}
          </Breadcrumb.Item>
      );
    }

    if (href3 && thirdLevelText) {
      items.push(
          <Breadcrumb.Item key="3" href={href3} onClick={onClick3 || null}>
            {thirdLevelText}
          </Breadcrumb.Item>
      );
    }

    const activeText = forthLevelText || thirdLevelText || secondLevelText;
    if (activeText) {
      items.push(
          <Breadcrumb.Item key="4" active>
            {activeText}
          </Breadcrumb.Item>
      );
    }

    return items;
  };

  return (
      <div className="knoa-region knoa-nav-region" tabIndex="-1">
        <nav className="knoa-nav-breadCrumb" aria-label="breadcrumb">
          <Breadcrumb className="knoa-breadCrumb">{renderItems()}</Breadcrumb>
        </nav>
      </div>
  );
};

KnoaBreadcrumb.propTypes = {
  href: PropTypes.string.isRequired,
  firstLevelText: PropTypes.string.isRequired,
  href2: PropTypes.string,
  secondLevelText: PropTypes.string,
  href3: PropTypes.string,
  thirdLevelText: PropTypes.string,
  forthLevelText: PropTypes.string,
  onClick2: PropTypes.func,
  onClick3: PropTypes.func
};

export default KnoaBreadcrumb;